import { render, staticRenderFns } from "./NotificationGroupsView.vue?vue&type=template&id=3dc81497&scoped=true&"
import script from "./NotificationGroupsView.vue?vue&type=script&lang=js&"
export * from "./NotificationGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc81497",
  null
  
)

export default component.exports